export default "__VITE_ASSET__82467f7e__"